<template>
    <dynamic-toolbar
        :icon="'mdi-timer-alert'"
        :title="'Runout Analysis'"
        :color="moduleColor"
        :theme="'dark'"
        :loading="anyLoading"
        :dense="false"
    >
        <template #subtitle v-if="!show.inputForm">
            - {{ response?.order?.station?.Name }}
            <v-chip
                label
                class="mx-2"
                dark
                :color="
                    compareDates(
                        response.reportedRunoutDateTime,
                        response.order.StStart
                    ) < 1
                        ? 'red'
                        : 'green'
                "
            >
                Did it run out?&nbsp;
                <b>
                    {{
                        compareDates(
                            response.reportedRunoutDateTime,
                            response.order.StStart
                        ) < 1
                            ? 'Yes'
                            : 'No'
                    }}
                </b>
            </v-chip>
            <!--<v-chip label color="teal" class="my-1 mr-1">
                Consumption spikes
            </v-chip>-->
        </template>
        <template #buttons>
            <div class="text-center">
                <v-menu
                    v-model="reportMenu.show"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    offset-y
                    left
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="blue"
                            dark
                            depressed
                            large
                            v-bind="attrs"
                            v-on="on"
                        >
                            Get Report
                        </v-btn>
                    </template>

                    <v-card>
                        <v-card-title>
                            Runout Report
                        </v-card-title>
                        <v-card-subtitle>
                            Sites that did runout in a date range
                        </v-card-subtitle>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-menu
                                        v-model="reportMenu.datemenu.start"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="reportMenu.daterange.start"
                                                label="From"
                                                prepend-inner-icon="mdi-calendar"
                                                single-line
                                                placeholder="YYYY-MM-DD"
                                                v-mask="'####-##-##'"
                                                v-bind="attrs"
                                                v-on="on"
                                                hint="Start date"
                                                persistent-hint
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="reportMenu.daterange.start"
                                            no-title
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-menu
                                        v-model="reportMenu.datemenu.end"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="reportMenu.daterange.end"
                                                label="To"
                                                prepend-inner-icon="mdi-calendar"
                                                single-line
                                                placeholder="YYYY-MM-DD"
                                                v-mask="'####-##-##'"
                                                v-bind="attrs"
                                                v-on="on"
                                                hint="End date"
                                                persistent-hint
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="reportMenu.daterange.end"
                                            no-title
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                text
                                @click="reportMenu.show = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                color="primary"
                                text
                                @click="getReport()"
                            >
                                Download
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </div>
            <v-btn
                v-show="show.inputForm"
                plain
                @click="$emit('input-default-data')"
                dark
                class="mr-2"
            >
                <v-icon left>mdi-cursor-text</v-icon>
                Input default data
            </v-btn>
            <div v-show="!show.inputForm">
                <!--<v-btn
                    depressed
                    plain
                    @click="$emit('show-comments')"
                    dark
                    class="mr-2"
                >
                    <v-icon left>mdi-comment</v-icon>
                    Show Comments
                </v-btn>-->
                <v-btn plain depressed @click="$emit('toggle-input-form')" dark>
                    <v-icon left>mdi-form-select</v-icon>
                    Show Input Form
                </v-btn>
            </div>
        </template>
    </dynamic-toolbar>
</template>

<script>
import DynamicToolbar from '@/components/Global/Utils/DynamicToolbar.vue';
import DateRangeMenu from '@/components/Global/Utils/DateRangeMenu.vue';
import { dateUtils } from '../../mixins/dateUtils';
import { mask } from 'vue-the-mask';
import axios from 'axios';

export default {
    name: 'Toolbar',
    directives: { mask },
    components: {
        DynamicToolbar,
        DateRangeMenu
    },
    props: {
        moduleColor: String,
        show: Object,
        anyLoading: Boolean,
        response: Object
    },
    mixins: [dateUtils],
    data: () => ({
        reportMenu: {
            show: false,
            daterange: {
                start: '',
                end: '',
            },
            datemenu: {
                start: false,
                end: false,
            },
        }
    }),
    methods: {
        getReport() {
            console.log('Get report');
            console.log('Daterange: ', this.reportMenu);

            if (
                !this.reportMenu.daterange.start ||
                !this.reportMenu.daterange.end ||
                !this.isValidDate(this.reportMenu.daterange.start) ||
                !this.isValidDate(this.reportMenu.daterange.end)
            ) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Please select a date range'
                });
                return;
            }

            console.log('Request report');
            let str = this.$store;
            str.state.isLoading = true;
            let filename = 'RunoutReport_From_' + this.reportMenu.daterange.start +
                            '_To_' + this.reportMenu.daterange.end + '.xlsx';
            let params = {
                daterange: this.reportMenu.daterange,
                filename,
            }

            axios
                .post(
                    'v2/analysis/runout/report', params,
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        isValidDate(dateString) {
            const regex = /^\d{4}-\d{2}-\d{2}$/;

            if (!regex.test(dateString)) {
                return false;
            }

            const date = new Date(dateString);

            const isValid =
                date instanceof Date && 
                !isNaN(date) && 
                dateString === date.toISOString().split("T")[0];

            return isValid;
        },
    }
};
</script>
